/** Upcoming Work row-open destinations. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, UpcomingWork } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

/**
 * Retained deliberately: this was the row-open destination before 2026-09, and opening the Service
 * Line for a clicked occurrence confused clients. Product can revert by pointing the manifest's
 * `itemInteraction.navigate` back at this function — do not delete it.
 */
export async function navigateToUpcomingWork(item: UpcomingWork): Promise<void> {

  const serviceLineId = item.serviceLine?._id;
  if (!serviceLineId) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.ServiceLine,
    id: serviceLineId,
  });
}

/** Opens the occurrence the user actually clicked (`_id` is `taskId:visitDate`), read-only. */
export async function navigateToUpcomingWorkOccurrence(item: UpcomingWork): Promise<void> {

  if (!item._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'preview',
    entity: ActivityEntityName.UpcomingWork,
    id: item._id,
  });
}
